module.exports = __webpack_public_path__ + "static/media/thumbnail.e5b92a0f.jpg";